import React, { useEffect } from 'react';
import styles from './style.module.less';
import { Row, Col, Button, Tabs, Image, Spin, message, Modal } from 'antd';
import { useState } from 'react';
import starFilled from '../../../common/assets/images/fullHeart.svg';
import star from '../../../common/assets/images/heart.svg';
import DownloadIcon from '../../../common/assets/images/DownloadIcon.svg';
import AddFriendIcon from '../../../common/assets/images/AddFriend.svg';
import FriendIcon from '../../../common/assets/images/Friend.svg';
// import BlockIcon from '../../../common/assets/images/BlockFriend.svg';
// import { DownloadOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
// import profilePic from '../../../common/assets/images/card1.jpg';
import Aboutme from './Aboutme';
import FamilyDetails from './FamilyDetails';
import Education from './Education';
import Horoscope from './Horoscope';
import DesiredPartner from './DesiredPartner';
import ContactDetails from './Contact';
import { likeProfile, unlikeProfile } from '../../ListView/redux/slice';
// import { blockProfile } from '../../ProfileView/redux/slice';
// import ChatComponent from 'pages/ChatNowComponent/components/ChatSystem';
// import { respondActions } from '../redux/slice';

const { TabPane } = Tabs;

const UserView = ({
  profile_list,
  profileLoading,
  onSubmit,
  handleDownload,
  downloadLoading,
  handleRequestAction,
  blockProfileLoading,
  handleBlock
}) => {
  const [isLiked, setIsLiked] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  // const [openChat, setOpenChat] = useState(false);
  const dispatch = useDispatch();
  // console.log('profileLoading', profile_list);
  // console.log('downloadLoading', downloadLoading);

  const profile = profile_list?.Profiles?.[0];

  // console.log('profile_list', profile?.is_requested);
  // console.log('profile_list', profile_list?.id);
  const profile_name = profile_list?.Profiles?.[0]?.profile_name;
  const profile_id = profile?.id;
  const user_id = profile_list?.id;

  // console.log('profile_list', profile_list?.Profiles?.[0]?.is_favourite);
  useEffect(() => {
    if (profile_list?.Profiles?.[0]?.is_favourite) {
      setIsLiked(true);
    }
  }, [profile_list]);

  const handleSendRequest = (profile_id) => {
    // console.log('Send Request Profile', profile_id);
    onSubmit({ profile_id, action: 'send_request' });
  };

  const handleShortProfileRequest = (profile_id) => {
    // console.log('Short Profile', profile_id);
    onSubmit({ profile_id, action: 'short_profile' });
  };

  // const [mainImage, setMainImage] = useState(profile?.ProfileImages?.[0]);
  const [mainImage, setMainImage] = useState(null);
  useEffect(() => {
    if (profile?.ProfileImages?.length > 0) {
      setMainImage(profile.ProfileImages[0]); // Set first image as default
    }
  }, [profile?.ProfileImages]);
  const handleImageClick = (image) => {
    setMainImage(image);
  };

  if (profileLoading) {
    return (
      <div className={styles.spinnerContainer}>
        <Spin size="large" />
      </div>
    );
  }

  const handleLikeClick = async (e, profileId) => {
    e.stopPropagation(); // Prevents triggering parent onClick
    const newLikedStatus = !isLiked;
    setIsLiked(newLikedStatus);

    // console.log('profileId:', profileId, 'Liked:', newLikedStatus); // ✅ Console log ID & status

    let payload = { profile_id: profileId }; // Send profile ID in API request

    try {
      // console.log('Form Submitted:', payload);

      const response = newLikedStatus
        ? await dispatch(likeProfile(payload)).unwrap() // If liked → Call Like API
        : await dispatch(unlikeProfile(payload)).unwrap(); // If unliked → Call Unlike API
      if (response?.success) {
        message.success(
          response.message || (newLikedStatus ? 'Liked!' : 'Unliked!')
        );
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      message.error(
        error?.message || 'Failed to submit the form. Please try again.'
      );
    }
  };

  // const handleDownload = (user_id) => {
  //   console.log('Download button clicked!', user_id);
  //   // Add your download logic here
  // };

  // const handleRequestAction = async (status, profileId) => {
  //   console.log('status', status);
  //   const payload = {
  //     requestor_profile_id: profileId,
  //     response_type: status
  //   };
  //   console.log('payload', payload);
  //   const result = await dispatch(respondActions(payload));
  //   console.log('Shortlist Response:', result);
  // };
  // console.log('profile?.is_request_received', profile?.is_request_received);

  // const handleBlock = (profileId) => {
  //   // window.location.href = '/dashboard';
  //   // console.log('Block Profile', payload);
  //   let payload = { blocked_profile_id: profileId };
  //   // dispatch(blockProfile(payload));
  // };
  console.log('blockProfileLoading', blockProfileLoading);
  console.log('profile_id', profile?.is_req_accepted);

  const showConfirm = (profileId) => {
    Modal.confirm({
      title: (
        <span className={styles.modalTitle}>
          Are you sure you want to block this user?
        </span>
      ),
      content: (
        <span className={styles.modalContent}>
          {/* This user will no longer be able to interact with you or view your activity. This action is irreversible. */}
          Once blocked, this user won’t be able to message you or see your
          profile. You won’t receive any more updates from them.
          {/* Blocking ensures your privacy by cutting all contact and visibility from this user. This change is final. */}
        </span>
      ),
      okText: 'Yes, Block',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk() {
        handleBlock(profileId);
      }
    });
  };

  return (
    <>
      <div className={styles.maincontainer}>
        <Row className={styles.secondcontainer}>
          <Col
            className={styles.leftBox}
            xl={24}
            lg={7}
            md={24}
            sm={24}
            xs={24}
          >
            {profile?.is_req_accepted ? (
              // <div className={styles.actionButtons}>
              <Button
                className={styles.back}
                onClick={() => handleRequestAction('reject', profile_id)}
                // disabled={profile?.is_received_req_rejected}
                // style={{ color: '#D20B0B' }} // Optional style for reject
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_25_2)">
                    <path
                      d="M8.60141 9.55334C11.2394 9.55334 13.378 7.41479 13.378 4.77676C13.378 2.13873 11.2394 0.000183105 8.60141 0.000183105C5.96338 0.000183105 3.82483 2.13873 3.82483 4.77676C3.82483 7.41479 5.96338 9.55334 8.60141 9.55334Z"
                      fill="#D20B0B"
                    />
                    <path
                      d="M2.41131 18.1519L5.77231 19.0373C7.23008 19.4209 9.57808 19.3759 11.0199 18.936L12.3791 18.5192C13.1431 19.4233 14.2831 19.9998 15.5568 19.9998C17.8509 19.9998 19.7175 18.1332 19.7175 15.8392C19.7175 13.5445 17.8509 11.6779 15.5568 11.6779C15.1681 11.6779 14.7935 11.7357 14.4366 11.8356C13.5741 10.7925 12.4666 10.0029 11.1057 9.5599C10.313 10.0251 9.39478 10.2962 8.41117 10.2962C7.42307 10.2962 6.49964 10.0223 5.70453 9.55298C3.16354 10.3491 1.36407 12.2811 0.420582 14.8099C-0.107536 16.2224 0.953542 17.768 2.41131 18.1519ZM15.5461 12.2247C17.5286 12.2247 19.1354 13.8315 19.1354 15.8146C19.1354 17.7971 17.5286 19.4043 15.5461 19.4043C13.5637 19.4043 11.9565 17.7974 11.9565 15.8146C11.9569 13.8315 13.5633 12.2247 15.5461 12.2247Z"
                      fill="#D20B0B"
                    />
                    <path
                      d="M13.536 17.6511C13.6623 17.7902 13.8355 17.86 14.0098 17.86C14.1641 17.86 14.3197 17.8047 14.4425 17.6923L15.5458 16.6838L16.6487 17.6923C16.7718 17.8047 16.9271 17.86 17.0814 17.86C17.255 17.86 17.4283 17.7898 17.5552 17.6511C17.7942 17.39 17.7758 16.9836 17.5144 16.7447L16.4965 15.814L17.5144 14.8833C17.7758 14.6443 17.7942 14.2386 17.5552 13.9768C17.3162 13.715 16.9105 13.6973 16.6487 13.936L15.5458 14.9452L14.4425 13.936C14.1807 13.697 13.7754 13.7153 13.536 13.9768C13.297 14.2386 13.315 14.6443 13.5768 14.8833L14.595 15.814L13.5768 16.7447C13.3154 16.9836 13.2974 17.39 13.536 17.6511Z"
                      fill="#D20B0B"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_25_2">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                {/* {profile?.is_req_accepted ? 'Declined' : 'Un Friend'} */}
                Unfriend
              </Button>
            ) : (
              // </div>
              ''
            )}
            <Button
              className={styles.back}
              // onClick={() => handleBlock(profile_id)}
              onClick={() => showConfirm(profile_id)}
              loading={blockProfileLoading}
              disabled={blockProfileLoading}
            >
              {/* <img
                src={BlockIcon}
                alt="Block"
                className={styles.blockiconStyle}
              /> */}
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11 9.16665C13.0251 9.16665 14.6667 7.52502 14.6667 5.49998C14.6667 3.47494 13.0251 1.83331 11 1.83331C8.975 1.83331 7.33337 3.47494 7.33337 5.49998C7.33337 7.52502 8.975 9.16665 11 9.16665Z"
                  fill="#D20B0B"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M16.5 14.4375C16.1516 14.4375 15.8088 14.5258 15.5038 14.6941C15.1987 14.8625 14.9413 15.1053 14.7554 15.4001C14.5696 15.6948 14.4615 16.0318 14.4412 16.3796C14.4208 16.7275 14.489 17.0748 14.6392 17.3892L17.3892 14.6392C17.1116 14.5062 16.8078 14.4372 16.5 14.4375ZM18.3608 15.6108L15.6108 18.3608C15.9957 18.5446 16.4281 18.6046 16.8485 18.5325C17.2688 18.4604 17.6565 18.2597 17.9581 17.9581C18.2597 17.6565 18.4604 17.2688 18.5325 16.8485C18.6046 16.4281 18.5446 15.9957 18.3608 15.6108ZM13.0625 16.5C13.0625 15.5883 13.4247 14.714 14.0693 14.0693C14.714 13.4247 15.5883 13.0625 16.5 13.0625C17.4117 13.0625 18.286 13.4247 18.9307 14.0693C19.5753 14.714 19.9375 15.5883 19.9375 16.5C19.9375 17.4117 19.5753 18.286 18.9307 18.9307C18.286 19.5753 17.4117 19.9375 16.5 19.9375C15.5883 19.9375 14.714 19.5753 14.0693 18.9307C13.4247 18.286 13.0625 17.4117 13.0625 16.5Z"
                  fill="#D20B0B"
                />
                <path
                  d="M14.0498 12.3567C13.33 12.7825 12.7335 13.3886 12.3193 14.1151C11.9051 14.8417 11.6873 15.6637 11.6875 16.5C11.6875 17.4809 11.9809 18.392 12.4841 19.1519C12.0062 19.2173 11.5115 19.2503 11 19.2509C7.45621 19.2509 4.58337 17.6101 4.58337 15.5843C4.58337 13.5584 7.45621 11.9176 11 11.9176C12.1037 11.9176 13.1423 12.0771 14.0498 12.3576"
                  fill="#D20B0B"
                />
              </svg>
              Block
            </Button>
          </Col>
          <Col className={styles.colpro} xl={6} lg={7} md={24} sm={24} xs={24}>
            {/* Main Image with Preview */}
            <Row style={{ justifyContent: 'center' }}>
              {mainImage && (
                <Image
                  src={mainImage.objectKey}
                  alt="Profile picture"
                  className={styles.leftImg}
                  preview={{
                    src: mainImage.objectKey // Enable preview only here
                  }}
                />
              )}
            </Row>

            {/* Thumbnail Images (No Preview) */}
            <Row className={styles.rowImg} gutter={24}>
              {profile?.ProfileImages?.slice(0, 4).map((image) => (
                <Image
                  key={image.id}
                  src={image.objectKey}
                  alt={image.originalName}
                  className={styles.lImg}
                  preview={false} // Disable preview for thumbnails
                  onClick={() => handleImageClick(image)}
                />
              ))}
            </Row>
          </Col>

          <Col
            // style={{
            //   paddingLeft: '41px',
            //   // width:"920px"
            //   width: '72%',
            //   paddingRight: '105px'
            // }}
            className={styles.colform}
            xl={16}
            lg={16}
            md={24}
            sm={24}
            xs={24}
          >
            <div>
              <Row className={styles.rightform}>
                <Col>
                  <span className={styles.headName}> {profile_name} </span>
                </Col>
                <Row style={{ alignItems: 'center' }}>
                  {/*  <Button
                    className={styles.btnTop}
                    style={{ color: '#D20B0B' }}
                    onClick={() => setOpenChat(true)}
                  >
                    Chat Now
                  </Button>

                  {openChat && (
                    <ChatComponent closeChat={() => setOpenChat(false)} />
                  )}
                  <div className={styles.vBorder}></div> */}
                  <Button
                    className={styles.btnTop}
                    // onClick={() => setIsLiked(!isLiked)}
                    onClick={(e) => handleLikeClick(e, profile_id)}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                  >
                    <img
                      src={isLiked || isHovered ? starFilled : star}
                      alt="star"
                    />
                    Like
                  </Button>
                  {/* <Divider type="vertical" /> */}
                  <div className={styles.vBorder}></div>
                  {/* <Button
                    className={styles.btnTop}
                    onClick={() => handleSendRequest(profile_id)}
                    disabled={profile?.is_requested}
                    style={{ color: '#D20B0B' }}
                  >
                    Send Request
                    <img
                      src={AddFriendIcon}
                      alt="Add Friend"
                      className={styles.iconStyle}
                    />
                    {profile?.is_requested ? 'Request Sent' : 'Add Friend'}
                  </Button> */}

                  {/* /////////////// Logic 2 /////////////////// */}

                  {profile?.is_req_accepted ? (
                    // Step 1: Already friends
                    <Button
                      className={styles.btnTop}
                      // onClick={() => handleSendRequest(profile_id)}
                      // disabled
                      style={{ color: '#D20B0B' }}
                    >
                      <img
                        src={FriendIcon}
                        alt="Add Friend"
                        className={styles.iconStyle}
                      />
                      Friend
                    </Button>
                  ) : profile?.is_request_received ? (
                    <div className={styles.actionButtons}>
                      <Button
                        className={styles.buttonTop}
                        onClick={() =>
                          handleRequestAction('accept', profile_id)
                        }
                        disabled={profile?.is_req_accepted}
                        style={{ color: '#D20B0B' }} // Optional style for approve
                      >
                        {profile?.is_req_accepted ? 'Friend' : 'Accept'}
                      </Button>
                      <Button
                        className={styles.buttonTop}
                        onClick={() =>
                          handleRequestAction('reject', profile_id)
                        }
                        disabled={profile?.is_received_req_rejected}
                        style={{ color: '#D20B0B' }} // Optional style for reject
                      >
                        {profile?.is_received_req_rejected
                          ? 'Declined'
                          : 'Decline'}
                      </Button>
                    </div>
                  ) : (
                    <Button
                      className={styles.btnTop}
                      onClick={() => handleSendRequest(profile_id)}
                      disabled={profile?.is_requested}
                      style={{ color: '#D20B0B' }}
                    >
                      <img
                        src={AddFriendIcon}
                        alt="Add Friend"
                        className={styles.iconStyle}
                      />
                      {profile?.is_requested ? 'Request Sent' : 'Add Friend'}
                    </Button>
                  )}

                  {/* Logic 3 /////////////////// */}

                  {/* {profile?.is_request_received === true ? (
                    // CASE 1: You received a connection request
                    <div className={styles.actionButtons}>
                      Conditional: Follow Back
                      {profile?.is_received_req_accepted &&
                      !profile?.is_sent_req_accepted &&
                      !profile?.is_requested ? (
                        <Button
                          className={styles.buttonTop}
                          onClick={() => handleSendRequest(profile_id)}
                          disabled={profile?.is_requested}
                          style={{ color: '#D20B0B' }}
                        >
                          {profile?.is_requested
                            ? 'Request Sent'
                            : 'Follow Back'}
                        </Button>
                      ) : (
                        // Accept / Accepted button
                        <Button
                          className={styles.buttonTop}
                          onClick={() =>
                            handleRequestAction('accept', profile_id)
                          }
                          disabled={profile?.is_received_req_accepted}
                          style={{ color: '#D20B0B' }}
                        >
                          {profile?.is_received_req_accepted
                            ? 'Accepted'
                            : 'Accept'}
                        </Button>
                      )}

                      Decline Button
                      <Button
                        className={styles.buttonTop}
                        onClick={() =>
                          handleRequestAction('reject', profile_id)
                        }
                        disabled={profile?.is_received_req_rejected}
                        style={{ color: '#D20B0B' }}
                      >
                        {profile?.is_received_req_rejected
                          ? 'Declined'
                          : 'Decline'}
                      </Button>
                    </div>
                  ) : (
                    // CASE 2: No request received
                    <>
                      {profile?.is_requested &&
                      profile?.is_received_req_accepted &&
                      profile?.is_sent_req_accepted ? (
                        // Both accepted and request sent — Following
                        <Button
                          className={styles.btnTop}
                          disabled
                          style={{ color: '#0B8A20' }}
                        >
                          Following
                        </Button>
                      ) : profile?.is_requested &&
                        (profile?.is_received_req_accepted ||
                          profile?.is_sent_req_accepted) ? (
                        // One-sided acceptance — also treat as Following
                        <Button
                          className={styles.btnTop}
                          disabled
                          style={{ color: '#0B8A20' }}
                        >
                          Following
                        </Button>
                      ) : (
                        // Default case — Send Request or Request Sent
                        <Button
                          className={styles.btnTop}
                          onClick={() => handleSendRequest(profile_id)}
                          disabled={profile?.is_requested}
                          style={{ color: '#D20B0B' }}
                        >
                          {profile?.is_requested
                            ? 'Request Sent'
                            : 'Send Request'}
                        </Button>
                      )}
                    </>
                  )} */}

                  {/* Logic 4 //////////////------------ */}

                  {/* {profile?.is_requested &&
                  profile?.is_received_req_accepted &&
                  profile?.is_sent_req_accepted ? (
                    // CASE: Both accepted — Following
                    <div className={styles.actionButtons}>
                      <Button
                        className={styles.buttonTop}
                        disabled
                        style={{ color: '#D20B0B' }}
                      >
                        Following
                      </Button>
                      <Button
                        className={styles.buttonTop}
                        onClick={() =>
                          handleRequestAction('reject', profile_id)
                        }
                        disabled={profile?.is_received_req_rejected}
                        style={{ color: '#D20B0B' }}
                      >
                        {profile?.is_received_req_rejected
                          ? 'Declined'
                          : 'Decline'}
                      </Button>
                    </div>
                  ) : (profile?.is_requested &&
                      profile?.is_received_req_accepted &&
                      !profile?.is_sent_req_accepted &&
                      !profile?.is_request_received) ||
                    (profile?.is_requested &&
                      profile?.is_sent_req_accepted &&
                      !profile?.is_received_req_accepted &&
                      !profile?.is_request_received) ? (
                    // CASE: One-sided accepted — Also Following
                    <Button
                      className={styles.buttonTop}
                      disabled
                      style={{ color: '#D20B0B' }}
                    >
                      Following
                    </Button>
                  ) : profile?.is_request_received === true ? (
                    // CASE: You received a connection request
                    <div className={styles.actionButtons}>
                      {profile?.is_received_req_accepted &&
                      !profile?.is_sent_req_accepted &&
                      profile?.is_request_received ? (
                        <Button
                          className={styles.buttonTop}
                          onClick={() => handleSendRequest(profile_id)}
                          disabled={profile?.is_requested}
                          style={{ color: '#D20B0B' }}
                        >
                          {profile?.is_requested
                            ? 'Request Sent'
                            : 'Follow Back'}
                        </Button>
                      ) : (
                        // Accept / Accepted button
                        <Button
                          className={styles.buttonTop}
                          onClick={() =>
                            handleRequestAction('accept', profile_id)
                          }
                          disabled={profile?.is_received_req_accepted}
                          style={{ color: '#D20B0B' }}
                        >
                          {profile?.is_received_req_accepted
                            ? 'Accepted'
                            : 'Accept'}
                        </Button>
                      )}

                      <Button
                        className={styles.buttonTop}
                        onClick={() =>
                          handleRequestAction('reject', profile_id)
                        }
                        disabled={profile?.is_received_req_rejected}
                        style={{ color: '#D20B0B' }}
                      >
                        {profile?.is_received_req_rejected
                          ? 'Declined'
                          : 'Decline'}
                      </Button>
                    </div>
                  ) : (
                    // CASE: No request received — Send Request or Request Sent
                    <Button
                      className={styles.btnTop}
                      onClick={() => handleSendRequest(profile_id)}
                      disabled={profile?.is_requested}
                      style={{ color: '#D20B0B' }}
                    >
                      {profile?.is_requested ? 'Request Sent' : 'Send Request'}
                    </Button>
                  )} */}

                  {/* <Divider type="vertical" /> */}
                  <div className={styles.vBorder}></div>
                  <Button
                    className={styles.btnTop}
                    onClick={() => handleShortProfileRequest(profile_id)}
                    disabled={profile?.is_shortlisted}
                    style={{ color: '#D20B0B' }}
                  >
                    {/* ShortList Profile */}
                    {profile?.is_shortlisted
                      ? 'Shortlisted'
                      : 'ShortList Profile'}
                  </Button>
                  {/* <div className={styles.vBorder}></div>
                  <Button className={styles.btnTop}> Chat Now</Button> */}
                  <div className={styles.vBorder}></div>
                  <Button
                    className={styles.btnTop}
                    onClick={() => handleDownload(user_id)}
                    loading={downloadLoading}
                    disabled={downloadLoading}
                  >
                    {/* <DownloadOutlined /> Download */}
                    <img src={DownloadIcon} alt="Download" />
                    Download
                  </Button>
                </Row>
              </Row>
              {/* <Divider type="horizontal" /> */}
              <Row className={styles.info}>
                <Tabs
                  defaultActiveKey="1"
                  centered
                  className={styles.tabstyles}
                  tabBarStyle={{
                    display: 'flex',
                    justifyContent: 'space-evenly',
                    width: '100%'
                  }}
                >
                  <TabPane
                    tab="ABOUT ME"
                    key="1"
                    // style={{ fontSize: '12px' }}
                  >
                    <Aboutme profile_list={profile_list} />
                  </TabPane>
                  <TabPane tab="FAMILY DETAILS" key="2">
                    <FamilyDetails profile_list={profile_list} />
                  </TabPane>
                  <TabPane tab="EDUCATION & CAREER" key="3">
                    <Education profile_list={profile_list} />
                  </TabPane>
                  <TabPane tab="HOROSCOPE" key="4">
                    <Horoscope profile_list={profile_list} />
                  </TabPane>
                  {/* {profile?.is_requested && profile.is_request_received ? ( */}
                  {profile?.is_req_accepted ? (
                    <TabPane tab="CONTACT" key="5">
                      <ContactDetails profile_list={profile_list} />
                    </TabPane>
                  ) : null}
                  <TabPane tab="DESIRED PARTNER" key="6">
                    <DesiredPartner profile_list={profile_list} />
                  </TabPane>
                </Tabs>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
      {/* )} */}
    </>
  );
};

export default UserView;
